// src/pages/SafetyWatchPage.js
// Top-level page wrapper for the Safety Watch prototype.

import React from "react";
import SafetyWatchPanel from "../components/SafetyWatch/SafetyWatchPanel";
import { useEmbeddedPage } from "../hooks/useEmbeddedPage";
import { GroqDrawerTrigger } from "../components/GroqDrawerTrigger";

const SafetyWatchPage = () => {
  const { handleBack } = useEmbeddedPage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 dark:from-gray-900 dark:via-gray-800 dark:to-orange-900">
      <div className="container mx-auto px-4 py-6 sm:py-8">
        <SafetyWatchPanel />
      </div>
      <GroqDrawerTrigger />
    </div>
  );
};

export default SafetyWatchPage;
